import { getBaseApi } from "../api";

const api = getBaseApi();

export const createInquiry = async (data: {subject?: string; message: string; email: string; workspaceId: string}) => {
  const response = await api.post('/inquiries', data);
  return response.data;
};

export const getMyInquiries = async (userId: string, filter: {
  page?: number; 
  limit?: number; 
  status?: 'pending' | 'resolved';
  sort?: 'asc' | 'desc';
}) => {
  const searchParams = new URLSearchParams();
  searchParams.append('user', userId);
  
  Object.entries(filter).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value));
    }
  });
  
  const response = await api.get(`/inquiries?${searchParams.toString()}`);
  return response.data;
};

export const getInquiry = async (inquiryId: string) => {
  const response = await api.get(`/inquiries/${inquiryId}`);
  return response.data;
};

export const getInquiries = async (filter: {
  page?: number; 
  limit?: number; 
  status?: 'pending' | 'resolved';
  sort?: 'asc' | 'desc';
}) => {
  const response = await api.get(`/inquiries`, { params: filter });
  return response.data;
};

export const replyInquiry = async (inquiryId: string, data: { response: string }) => {
  const response = await api.post(`/inquiries/${inquiryId}/reply`, data);
  return response.data;
};

export const deleteMyInquiry = async (inquiryId: string) => {
  const response = await api.delete(`/inquiries/${inquiryId}/me`);
  return response.data;
};